module.exports = __webpack_public_path__ + "9717ecb4e1db90812ff199e27d446e19.MP3";